const PROJECT_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0];
const PROJECT_NAMES = [
    "Tripadvisor", "Plus", "Experiences", "Native", "Fusion",
    "Sponsored Placements", "Hotels", "Commerce", "Restaurants",
    "Search & Discovery", "Core UX", "Plan Mode", "DO NOT USE (test)",
];

export const PROJECT_MAP = Object.fromEntries(
    PROJECT_IDS.map((id, i) => [id, PROJECT_NAMES[i]])
);

export const getProjectName = (projectId) =>
    PROJECT_MAP[projectId] ?? `Project ${projectId}`;
